import { Component } from '@theme/component';

/**
 * Displays volume pricing table with expandable rows.
 * Shows pricing tiers based on quantity thresholds.
 *
 * @extends {Component}
 */
class VolumePricingComponent extends Component {
  /**
   * Toggles the expanded state of the volume pricing table
   */
  toggleExpanded() {
    this.classList.toggle('volume-pricing--expanded');
  }
  
  connectedCallback() {
    super.connectedCallback();
    // Ensure element is marked as ready (for Safari compatibility)
    this.classList.add('volume-pricing--ready');
  }
}

// Define custom element - inline definition in template ensures Safari compatibility
if (!customElements.get('volume-pricing')) {
  customElements.define('volume-pricing', VolumePricingComponent);
}
